import styles from '../../assets/styles/LandingPage/Article.module.scss';
import React from 'react';
import Header3 from './Header3';
import Footer from './Footer';
import { MimaButton, MimaText } from '../../components';
import img_solution2 from '../../assets/img/img_solution2.png';
import PlayStoreIcon from '../../assets/img/playstore.png';
import AppleStoreIcon from '../../assets/img/apple.png';
import constant from '../../utils/constant';
import { useNavigate } from 'react-router';
import { otherArticles } from '../../utils/utils';
import { Link } from 'react-router-dom';



const Article2 = () => {

    const appleIcon = <img src={AppleStoreIcon} className={styles.btn__icon} alt="Apple icon" />;

    const playIcon = <img src={PlayStoreIcon} className={styles.btn__icon} alt="Playstore icon" />;

    const navigate = useNavigate();

    const switchToSignup = () => {
        navigate(constant.Routes.SignUp);
    };

    const otherArticlesfiltered = otherArticles.filter((item, index) => index !== 1);

    return (
        <>
            <Header3 />
            <div className={styles.container}>
                <div className={styles.container_title}>
                    <MimaText variant="h3" align="center" color="var(--color-primary)">
                        Business Management Solutions Streamlining <br /> Operations and Driving Success.
                    </MimaText>
                </div>
                <img
                    src={img_solution2}
                    alt='Article'
                    className={styles.container_img}
                />
                <MimaText variant="body2" ml={1} mr={1} mb={2}>
                    In today's rapidly evolving business landscape, effective management is crucial for the success and growth of any organization. Business management solutions encompass a range of strategies, tools, and practices designed to optimize operations, enhance efficiency, and drive overall success. This comprehensive article will explore the various aspects of business management solutions, including their benefits, key components, implementation strategies, and emerging trends.
                </MimaText>
                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    Understanding Business Management Solutions
                </MimaText>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Importance and Benefits of Business Management Solutions
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Enhanced Operational Efficiency</li>
                    <li>Streamlined Workflows and Processes  </li>
                    <li>Improved Decision-Making</li>
                    <li>Scalability and Growth Opportunities </li>
                    <li>Competitive Advantage </li>
                </ul>

                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    Key Components of Business Management Solutions
                </MimaText>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Business Process Management (BPM)
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Workflow Automation</li>
                    <li>Process Mapping and Optimization</li>
                    <li>Performance Monitoring and Analysis</li>
                </ul>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Customer Relationship Management (CRM)
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Sales and Lead Management</li>
                    <li>Customer Data Management</li>
                    <li>Relationship Building and Customer Retention</li>
                </ul>

                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Enterprise Resource Planning (ERP)
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Integrated Data Management</li>
                    <li>Financial Management and Accounting </li>
                    <li>Supply Chain and Inventory Management</li>
                </ul>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Human Resources Management (HRM)
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Employee Onboarding and Offboarding </li>
                    <li>Performance Management </li>
                    <li>Training and Development</li>
                    <li>Payroll and Benefits Administration</li>
                </ul>
                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    Implementing Business Management Solutions / Assessing Organizational Needs and Goals
                </MimaText>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Selecting the Right Solutions
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Custom-Built vs. Off-the-Shelf Solutions</li>
                    <li>Scalability and Integration Considerations</li>
                    <li>User-Friendliness and Adoption</li>
                    <li>Vendor Evaluation and Selection</li>
                </ul>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Planning and Execution
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Project Management and Stakeholder Engagement</li>
                    <li>Data Migration and System Integration </li>
                    <li>Change Management and Training </li>
                </ul>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Monitoring and Continuous Improvement
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Key Performance Indicators (KPIs) </li>
                    <li>Data Analytics and Reporting</li>
                    <li>Feedback and Iterative Enhancements</li>
                </ul>
                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    Emerging Trends in Business Management Solutions
                </MimaText>
                <ul className={styles.container_olist}>
                    <li>Cloud-Based Solutions and SaaS Models  </li>
                    <li>Artificial Intelligence (AI) and Machine Learning (ML) </li>
                    <li>Robotic Process Automation (RPA) </li>
                    <li>Mobile and Remote Access</li>
                    <li>Data Security and Privacy</li>
                </ul>
                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    Mima: Your Comprehensive Business Solution
                </MimaText>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">
                    Mima is more than just a software platform; it is your all-in-one solution for efficiently managing every aspect of your business. With Mima by your side, you can seamlessly handle essential tasks, streamline operations, and gain valuable insights to drive your business forward. From the moment you sign up, Mima empowers you with an array of powerful features designed to simplify your daily business activities. Send professional invoices and receipts with ease, ensuring prompt payments and maintaining a polished brand image. Stay on top of your financials effortlessly by tracking income and expenses, making tax season a breeze. Mima even provides personalized alerts, keeping you informed of important deadlines and milestones. But the benefits don't stop there. Mima goes beyond basic accounting and finance management. With its comprehensive toolkit, you can effortlessly handle employee payroll, ensuring your team gets paid accurately and on time. Mima also allows you to manage your entire task list, ensuring no important assignment slips through the cracks. One of the key advantages of Mima is its powerful analytics capabilities. Dive deep into your business's performance metrics, gain valuable insights, and make data-driven decisions. Identify areas of improvement, discover growth opportunities, and stay ahead of the competition. Mima is continuously evolving to meet the needs of modern businesses. Our team is constantly working on new features and enhancements to provide you with an even more robust and comprehensive solution. With Mima, you can focus on what matters most: growing your business, while leaving the time-consuming administrative tasks to our intuitive and user-friendly platform Experience the full potential of business management with Mima. Join our growing community of satisfied users and unlock the tools you need to take your business to new heights. Get started today and see how Mima revolutionizes the way you manage your business.
                </MimaText>
                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    Some key services Mima offers:
                </MimaText>
                <ul className={styles.container_list}>
                    <li><b>Invoicing and Receipts:</b> TryMima.com provides a user-friendly platform to create and send professional invoices and receipts to clients. This streamlines the billing process, improves cash flow, and helps maintain a polished brand image.</li>
                    <li><b>Expense Tracking:</b> With TryMima.com, users can effortlessly track their business expenses. This feature allows for easy categorization and organization of expenses, ensuring accurate financial records and simplified tax filing.</li>
                    <li><b>Financial Analytics:</b> TryMima.com offers robust financial analytics tools that provide insights into business performance. Users can access key metrics, generate reports, and gain valuable data-driven insights to make informed decisions for their business.</li>
                    <li><b>Task Management:</b> Managing tasks and staying organized is made simple with TryMima.com. The platform allows users to create and manage their task lists, ensuring important assignments and deadlines are never missed.</li>
                    <li><b>Payroll Management:</b> TryMima.com simplifies the payroll process by offering tools to calculate and manage employee wages, deductions, and taxes. Users can ensure accurate and timely payments to their employees.</li>
                    <li><b>Personalized Alerts:</b> TryMima.com keeps users informed with personalized alerts. These alerts serve as reminders for important dates, tasks, or upcoming deadlines, helping users stay on top of their business responsibilities. </li>
                    <li><b>Growth and Expansion:</b> As a comprehensive business management solution, TryMima.com is dedicated to helping businesses grow and expand. By providing tools and insights, users can identify growth opportunities and make informed decisions to drive their business forward.</li>
                </ul>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left"> <span style={{ fontWeight: "700", cursor: "pointer", color: "var(--color-primary)" }} onClick={switchToSignup}>CLICK HERE</span> to sign up today and start enjoying the benefits of Mima Business.</MimaText>
                <div className={styles.slide__text_btn}>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.mima.mima"
                        style={{ textDecoration: 'none' }}>
                        <MimaButton
                            title="Get app on Android"
                            variant="outlined"
                            icon={playIcon}
                            width={30}
                        />
                    </a>

                    <a
                        href="https://apps.apple.com/us/app/mima-business/id6444887331"
                        style={{ textDecoration: 'none' }}>
                        <MimaButton
                            title="Get app on iPhone"
                            variant="outlined"
                            icon={appleIcon}
                            width={30}
                        />
                    </a>
                </div>

                <MimaText mt={2} mb={2} variant="smallBold">Related Articles</MimaText>
                <div className={styles.related}>
                    {otherArticlesfiltered.map((x, i) => (
                        <Link key={i} to={x.link} className={styles.related__card}>
                            <img
                                src={x.src}
                                alt={x.title}
                            />
                            <MimaText variant="bodyBold" mt={2}>{x.title}</MimaText>
                            <MimaText variant="smallBold" color="var(--color-primary)" mt={2}>Click Here</MimaText>
                        </Link>
                    ))}
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Article2;